var map = {
	"./BgImage.vue": "daa2",
	"./Footer.vue": "fd2d",
	"./HelloWorld.vue": "fdab",
	"./Logo.vue": "2241",
	"./MainContent.vue": "2133",
	"./Map.vue": "a0be",
	"./Map2.vue": "9cf4",
	"./References.vue": "df79",
	"./Sticks.vue": "20c6",
	"./Welcome.vue": "1ddd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6809";